module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_omiya@3x-3876132340da0f9a0f33e4c84d1a0041.webp";